__turbopack_context__.v({
  "actionRow": "OuHqJW_actionRow",
  "actions": "OuHqJW_actions",
  "bottom": "OuHqJW_bottom",
  "chip": "OuHqJW_chip",
  "content": "OuHqJW_content",
  "contentOverlay": "OuHqJW_contentOverlay",
  "creatorAvatar": "OuHqJW_creatorAvatar",
  "creatorPill": "OuHqJW_creatorPill",
  "creatorPillPlate": "OuHqJW_creatorPillPlate",
  "dropShadow": "OuHqJW_dropShadow",
  "footer": "OuHqJW_footer",
  "forMod": "OuHqJW_forMod",
  "frame-decor": "OuHqJW_frame-decor",
  "fullOverlay": "OuHqJW_fullOverlay",
  "glowing": "OuHqJW_glowing",
  "gradientOverlay": "OuHqJW_gradientOverlay",
  "header": "OuHqJW_header",
  "iconBadge": "OuHqJW_iconBadge",
  "image": "OuHqJW_image",
  "imageGroupContainer": "OuHqJW_imageGroupContainer",
  "imageGroupContainer4x4": "OuHqJW_imageGroupContainer4x4",
  "infoChip": "OuHqJW_infoChip",
  "link": "OuHqJW_link",
  "mantine-Badge-label": "OuHqJW_mantine-Badge-label",
  "mantine-Divider-root": "OuHqJW_mantine-Divider-root",
  "noHover": "OuHqJW_noHover",
  "noImage": "OuHqJW_noImage",
  "oneLine": "OuHqJW_oneLine",
  "reactions": "OuHqJW_reactions",
  "root": "OuHqJW_root",
  "statChip": "OuHqJW_statChip",
  "tipEnd": "OuHqJW_tipEnd",
  "tipRow": "OuHqJW_tipRow",
  "top": "OuHqJW_top",
  "winnerFirst": "OuHqJW_winnerFirst",
  "winnerSecond": "OuHqJW_winnerSecond",
  "winnerThird": "OuHqJW_winnerThird",
});
